/**
 * Window Globals
 *
 * @module
 */

/**
 * @typedef {Object} Ticker
 * @property {string} name
 * @property {string} symbol
 * @property {string} exchange
 */

/**
 * @typedef {Object} QuoteApiConfig
 * @property {string} app_id
 * @property {string} ticker
 * @property {string} market
 */

/**
 * @typedef {Object} FOOL_FREESITE
 * @property {string} env
 * @property {string} wpUserId
 * @property {string} isAdminUser
 * @property {string} siteUrl
 * @property {string} childThemeUrl
 * @property {string} parentThemeUrl
 * @property {string} isThemeDebugEnabled
 * @property {string} isOptimizingAssets
 * @property {string} isTickerPage
 * @property {string} isCustomCssDisabled
 * @property {object} assetsVersions
 * @property {string} themeMainJs
 * @property {object} post
 * @property {string} CDN_URL
 * @property {string} ajaxUrl
 * @property {string} postsListingApiUrl
 * @property {string} paginationApiUrl
 * @property {string} hasQuoteApi
 * @property {string} hasQuoteMediaApi
 * @property {string} isEmptyShell
 * @property {string} searchTerm
 * @property {Ticker} ticker
 * @property {string} tickerMovementLabel
 * @property {QuoteApiConfig} quoteApiConfig
 */

/** @type {FOOL_FREESITE} */
// @ts-ignore: FOOL_FREESITE is in window
const GLOBAL_FOOL_FREESITE = window.FOOL_FREESITE;

/**
 * @typedef {Object} SiteInfo
 * @property {string} appId
 * @property {string} brandCode
 * @property {string} domain
 * @property {string} envhost
 */

/** @type {SiteInfo} */
// @ts-ignore: FOOL_FREESITE is in window
const GLOBAL_SiteInfo = window.SiteInfo;

/**
 * @typedef {Object} FoolEcapData
 * @property {string} acceptTermsCheckboxUncheckedError
 * @property {string} adminAjaxUrl
 * @property {string} cookieDomain
 * @property {string} cookiePath
 * @property {string} invalidEmailAddressError
 * @property {string} isPost
 * @property {string} regwallCookie
 * @property {string} showTickle
 * @property {string} unknownErrorException
 */

/** @type {FoolEcapData} */
// @ts-ignore: FoolEcapData is in window
const GLOBAL_FoolEcapData = window.FoolEcapData;

export const FOOL_GLOBALS = {
    FOOL_FREESITE: GLOBAL_FOOL_FREESITE,
    SiteInfo: GLOBAL_SiteInfo,
    FoolEcapData:GLOBAL_FoolEcapData
};

/**
 * @param {string} globalObjectProperty '1' for true, false otherwise.
 * @return {boolean}
 */
export function isTrue(globalObjectProperty) {
    return parseInt(globalObjectProperty, 10) === 1;
}
